import styles from "./NavBar.module.css"
import {Link, useNavigate} from "react-router-dom";
import BellIcon from "./icon/BellIcon";
import {ProfileIcon} from "./icon/ProfileIcon";
import {getRole} from "../const/ForAuth";
import {Urls} from "../const/Urls";
export default function NavBar(){

    const nav = useNavigate()

    const onClick = () => {
        const role = getRole()
        if (role) nav('/myPage')
        else nav('/signin')
    }
    return(
        <header className={`sticky top-0 z-30 py-6 flex items-center w-full justify-between px-16 bg-white border-b`}>
                <div className={`font-extrabold text-[1.3rem] `}>
                    AITe시험</div>
                <div className={`flex gap-6 text-gray-400 `}>
                    <Link to="/" className={`text-lg font-light`}>홈</Link>
                    <Link to="/" className={`text-lg font-light`}>회사 및 협회 소개</Link>
                    <Link to="/" className={`text-lg font-light`}>번역 자격증</Link>
                    <Link to="/" className={`text-lg font-light`}>AITe 번역 전문가</Link>
                    <Link to="/" className={`text-lg font-light`}>프롬프트 언어전문가</Link>
                    <Link to="/" className={`text-lg font-light`}>공지사항</Link>
                </div>
                <div className={styles.iconContainer}>
                    <Link to="/alert"><BellIcon/></Link>
                    <div onClick={onClick}><ProfileIcon/></div>
                </div>
        </header>
    )
}